import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Globals, AuthenData } from '../globals/globals';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/map';


@Injectable()
export class ImageService {

    private messageSource = new BehaviorSubject<any>(null);
    currentMessage = this.messageSource.asObservable();
    constructor(private http: HttpClient, private global: Globals) { }

    getProductImage(): Observable<any> {
        return this.http.get<any>(this.global.BaseApiUrl + 'api/Image/GetProductImage')
    }

    getProductByCode(criteria): Observable<any> {
      return this.http.post<any>(this.global.BaseApiUrl + 'api/Image/GetProductCodeList', criteria)
  }

  chedkImageProduct(criteria): Observable<any> {
    return this.http.post<any>(this.global.BaseApiUrl + 'api/Image/ChedkImageProduct', criteria)
  }

  getProductIDByID(criteria): Observable<any> {
    return this.http.post<any>(this.global.BaseApiUrl + 'api/Image/GetProductIDByID', criteria)
  }


    saveImageProduct(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Image/CreateImageProduct', criteria)
    }

    updateImageProduct(criteria): Observable<any> {
        return this.http.post<any>(this.global.BaseApiUrl + 'api/Image/UpdateImageProduct', criteria)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/image.services.ts